__turbopack_context__.v({
  "pageContainer": "buy-client-module__QJNjaG__pageContainer",
  "productContainer": "buy-client-module__QJNjaG__productContainer",
});
